import React, { Component } from 'react';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { find } from 'lodash';
import * as actPaymentMethod from 'actions/setting/paymentMethod';
import SettingField from 'components/Fields/ReduxForm/SettingField/SettingField';
import DropdownBank from 'components/Fields/ReduxForm/DropdownBank/DropdownBank';
import SettingLetter from 'components/Fields/ReduxForm/SettingLetter/SettingLetter';

class BankAccountModal extends Component {
  _isUpdateBankAccount = () => {
    const { formValue } = this.props;
    return formValue;
  };

  _onChangeBankName = e => {
    this.props.dispatch(
      change('bankAccountModalForm', 'bank_name', e.target.value)
    );
  };

  _generateBankList = bankList => {
    return bankList.map(bank => {
      return {
        name: bank.bank_name,
        swift_code: bank.swift_code,
      };
    });
  };

  _onClickSubmit = () => {
    const {
      formValue: {
        bank_name: bankName,
        bank_account_number: bankcAccountNumber,
        holder_name: holderName,
      },
      bankList,
      businessBankAccountList,
    } = this.props;

    if (!bankName || !bankcAccountNumber || !holderName) {
      return;
    }

    const bankId = find(bankList, o => {
      return o.bank_name === bankName;
    }).id;
    const request = {
      account_holder_name: holderName,
      account_holder_number: bankcAccountNumber,
      bank_id: bankId,
    };

    this.props.dispatch(
      actPaymentMethod.onClickAddBankAccount(request, businessBankAccountList)
    );
  };

  render() {
    const { showBankAccountModalForm, bankList, handleClose } = this.props;
    const generatedBankList = this._generateBankList(bankList);
    return (
      <Modal show={showBankAccountModalForm} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{`Add Bank Account`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <form>
              <div className="form-group">
                <label>{`Bank`}</label>
                <Field
                  component={DropdownBank}
                  name="bank_name"
                  onChangeValue={e => {
                    this._onChangeBankName(e, generatedBankList);
                  }}
                  banks={generatedBankList}
                />
                <Field component="hidden" name="id" />
              </div>
              <div className="form-group">
                <label>{`Account Number`}</label>
                <Field
                  component={SettingField}
                  type="text"
                  placeholder="Account Number"
                  name="bank_account_number"
                  positiveNumberOnly
                  maxFractionDigits={0}
                  maxLength="25"
                />
              </div>
              <div className="form-group">
                <label>{`Account Holder Name`}</label>
                <Field
                  component={SettingLetter}
                  type="text"
                  placeholder="Holder Name"
                  name="holder_name"
                  maxLength="255"
                  letterOnly
                />
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this._onClickSubmit}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    showBankAccountModalForm,
    bankList,
    businessBankAccountList,
  } = state.setting.paymentMethod;
  return {
    formValue: getFormValues('bankAccountModalForm')(state),
    showBankAccountModalForm,
    bankList,
    businessBankAccountList,
  };
};

const FIELD_IS_REQUIRED = 'This field is required';

const validate = values => {
  const errors = {};
  if (!values.bank_account_number || values.bank_account_number.trim() === '') {
    errors.bank_account_number = FIELD_IS_REQUIRED;
  }
  if (!values.holder_name || values.holder_name.trim() === '') {
    errors.holder_name = 'This field is required';
  } else if (!/^[A-Za-z ]+$/.test(values.holder_name)) {
    errors.holder_name = 'This field must contains letters only';
  }
  if (!values.bank_name) {
    errors.bank_type = FIELD_IS_REQUIRED;
  }
  return errors;
};

const mapForm = {
  form: 'bankAccountModalForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default connect(mapStateToProps)(reduxForm(mapForm)(BankAccountModal));
